import { AfterViewInit, Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[avanoEllipsis]'
})
export class AvanoEllipsisDirective implements AfterViewInit {
  /** Input property to set the white-space style. */
  @Input() public useNoWrap = true;

  /** Input property to set the display style. */
  @Input() public displayBlock: boolean;

  /** Input property to set the title with the innerText. */
  @Input() public setTitle = true;

  constructor(private el: ElementRef) {
    this.el.nativeElement.style.textOverflow = 'ellipsis';
    this.el.nativeElement.style.overflow = 'hidden';
  }

  /** Checks the value of the input parameter and sets the tooltip. */
  public ngAfterViewInit(): void {
    // Needs to be done here because the element won't be rendered when the constructor of the directive is called.
    if (this.useNoWrap) {
      this.el.nativeElement.style.whiteSpace = 'nowrap';
    }

    if (this.displayBlock) {
      this.el.nativeElement.style.display = 'block';
    }
  }

  @HostListener('mouseover')
  public onMouseOver(): void {
    // Can't be done in the AfterViewInit-Hook because it will not trigger again if you, for example, change something
    // dynamically. The tooltip of the title in the view would then contain the old title.
    if (this.setTitle) {
      // removing the line breaks is needed for IE. Otherwise the tooltip also contains these line breaks
      // at the start and end and makes the tooltip larger then needed
      this.el.nativeElement.title = this.removeLineBreaks(this.el.nativeElement.textContent);
    }
  }

  /** Removes line breaks from the start and end of the given input. And multiple spaces/line breaks will be replaced by a single one. */
  private removeLineBreaks(input: string): string {
    if (input) {
      return input.replace(/^\s+|\s+$/g, '').replace(/\s{2,}/g, ' ');
    } else {
      return input;
    }
  }
}
